import { helpbuttonStyle, convertToLocalStyle, statusStyle } from '@bingads-webui-campaign-react/common-styles';
import { mergeStyleSets } from '@fluentui/react';
// import { ComponentSettings } from '@bingads-webui-theme-2018/theme-fluent';
import { merge } from '@bingads-webui-universal/primitive-utilities';
import { pagePaddingStyle } from '@bingads-webui-campaign-react/page-padding-style';

// export const pageRootClass = mergeStyles({
// });

export const staticStyles = mergeStyleSets({
  errorColor: {
    color: '#A80000',
  },
});

export const styles = (_, core) => {
  const helpButtonStyle = convertToLocalStyle(helpbuttonStyle({ palette: core.palette ?? {} }));
  const { palette } = core;
  return {
    '@global': {
      ...pagePaddingStyle(),
    },
    'listing-group-content-root': merge(
      {},
      // columnChooserStyle,
      // getColumnChooserOverrideStyle,
      statusStyle({ palette }),
      {
        '& .toolbar-container': {
          fontSize: 14,
          '& .navbar .container-fluid': {
            paddingLeft: 3,
          },
        },
        '& .ms-DetailsHeader .ms-DetailsHeader-cellName': {
          width: '100%',
        },
        '& #bulkEditContainer': {
          maxWidth: 'inherit',
        },
        '& .grid-header-helpId': helpButtonStyle,
        '& .listing-group-name-container': {
          whiteSpace: 'normal',
        },
        '& .campaign-details-list-pagination': {
          marginLeft: 15,
        },
        '& .listing-group-condition-cell .iconba.small-icon': {
          fontSize: 12,
        },
        '& .show-listing-group-selector': {
          color: palette.themePrimary,
        },
        '& #button-hierarchy-view': {
          borderRadius: '2px 0px 0px 2px',
        },
        '& #button-list-view': {
          borderRadius: '0px 2px 2px 0px',
        },
        '& .tree-view-cell': {
          display: 'flex',
        },
        '& .view-switch-button': {
          background: palette.white,
          color: palette.themePrimary,
          padding: '0px',
          width: 32,
          minWidth: 32,
          minHeight: 32,
          height: 32,
          margin: '0px !important',
        },
        '& .view-switch-button.active': {
          background: palette.themePrimary,
          border: '0px',
          '& .iconba': {
            color: palette.white,
          },
        },
        '& .view-switch-button.not-allowed': {
          cursor: 'not-allowed',
        },
        '& input[type="checkbox"]::after': {
          transitionDuration: '0s !important',
        },
        '& .grid-nodata': {
          padding: '20px 0 20px 40px',
          fontSize: '26px',
          lineHeight: '36px',
        },
        '& .iconba-ChevronDown': {
          lineHeight: '16px',
          opacity: 0,
          marginLeft: 5,
          fontSize: 11,
          color: palette.themeDark,
          '&:hover': {
            opacity: 1,
          },
        },
        '& .create-first-listing-group': {
          color: palette.neutralSecondary,
          fontSize: 26,
          lineHeight: '36px',
          padding: '20px 0 20px 40px',
        },
      }
    ),
  };
};
